import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

export const postEnrollmentToken = (machineUdi) => axios({
  method: 'post',
  url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/v1/caAuthority/devices/enrollment-token`,
  authRequired: true,
  headers: { 'Content-Type': 'application/json' },
  data: { machine_udi: machineUdi },
});
